import { useTranslation } from 'react-i18next';

import appStoreBadge from '../../images/landing/appstore_button.svg.webp';
import googlePlayBadge from '../../images/landing/google_play_button.svg.webp';
import { ANDROID_PLAY_STORE_URL, IOS_APP_STORE_URL } from '../../utils/storeUrls';
import { Button } from '../../styles/styles';
import {
  LoginPageCard,
  LoginPageFootnote,
  LoginPageFootnoteLink,
  LoginPageIntro,
  LoginPageSubtitle,
  LoginPageTitle,
  StoreBadge,
  StoreBadgeLink,
  StoreBadgesRow,
  StoreButtons,
} from '../landingPage/landingPage.styles';

export function WebSunsetNotice({ signedIn = false, email, onLogout }) {
  const { t } = useTranslation('registration');

  return (
    <LoginPageCard>
      <LoginPageIntro>
        <LoginPageTitle>{t('texts.webSunsetTitle')}</LoginPageTitle>
        <LoginPageSubtitle>{t('texts.webSunsetBody')}</LoginPageSubtitle>
        <LoginPageSubtitle>{t('texts.webSunsetAccount')}</LoginPageSubtitle>
        {signedIn && email ? (
          <LoginPageSubtitle>{t('texts.webSunsetSignedIn', { email })}</LoginPageSubtitle>
        ) : null}
      </LoginPageIntro>

      <StoreBadgesRow style={{ alignItems: 'center' }}>
        <StoreButtons>
          <StoreBadgeLink
            href={IOS_APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="App Store"
          >
            <StoreBadge src={appStoreBadge} alt="App Store" />
          </StoreBadgeLink>
          <StoreBadgeLink
            href={ANDROID_PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Google Play"
          >
            <StoreBadge src={googlePlayBadge} alt="Google Play" />
          </StoreBadgeLink>
        </StoreButtons>
      </StoreBadgesRow>

      {signedIn && onLogout ? (
        <Button
          type="button"
          outlineButton
          onClick={onLogout}
          width="auto"
          style={{ alignSelf: 'center' }}
        >
          {t('buttons.webSunsetLogout')}
        </Button>
      ) : null}

      {signedIn ? (
        <LoginPageFootnote>
          {t('texts.webSunsetSupport')}{' '}
          <LoginPageFootnoteLink href="mailto:info@healthy-pet.app">
            info@healthy-pet.app
          </LoginPageFootnoteLink>
        </LoginPageFootnote>
      ) : null}
    </LoginPageCard>
  );
}
